import { render, staticRenderFns } from "./DealModal.vue?vue&type=template&id=6552031e&scoped=true"
import script from "./DealModal.vue?vue&type=script&lang=js"
export * from "./DealModal.vue?vue&type=script&lang=js"
import style0 from "./DealModal.vue?vue&type=style&index=0&id=6552031e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552031e",
  null
  
)

export default component.exports